import { useState } from "react";
import { ChannelList } from "../../../Data/Data";
import SelectTypeContent from "./SubEnterContent/SelectTypeContent";
import ShowList from "./SubEnterContent/ShowList";
import TextContent from "./SubEnterContent/TextContent";
import TitleList from "./SubEnterContent/TitleList";
import BoxButton from "../../BoxButton/BoxButton";

function EnterContent() {

    const [channelName, setChannelName] = useState("")
    let optionsState;
    const [searchVal, setSearchVal] = useState("")
    const chooseSearchVal = (value) => {
        setSearchVal(value)
    }

    const selectedOption = (e) => {
        optionsState = e.target.value;
        console.log(optionsState)
    }
    const chooseName = (value) => {
        setChannelName(value)
    }
    const chooseCancel = (value) => {
        setChannelName(value)
    }

    return (
        <div className="flex flex-row-reverse h-full mb-4">
            <div className="w-1/5 m-4 border border-slate-200 rounded-lg h89">
                <TitleList
                    chooseSearchVal={chooseSearchVal}
                />
                <ShowList
                    searchVal={searchVal}
                    list={ChannelList}
                    chooseName={chooseName}
                />
            </div>
            {
                channelName === "" ?
                    <div className="flex flex-col items-center justify-center w-4/5 border border-slate-200 my-4 rounded-lg h89 bg-slate-50">
                        <img src="/image/megaphone.png" className="w-52" />
                        <p className="mt-7 t-purpleDark font-bold">لطفا نام یک کانال را انتخاب نمایید</p>
                    </div>
                    :
                    <div className="border border-slate-200 bg-slate-50 my-4 ml-4 px-12 py-8 rounded-lg h89 w-4/5">
                        <div className="flex flex-row-reverse items-center mb-4">
                            <p className="w-28 text-right"> : نام کانال</p>
                            <p className="bg-white border border-slate-200 p-1 w-2/5 text-right rounded">{channelName}</p>
                        </div>
                        <SelectTypeContent
                            optionsState={optionsState}
                            selectedOption={selectedOption}
                        />
                        <div className="flex flex-row-reverse items-center mb-4">
                            <p className="w-28 text-right"> : بارگذاری فایل </p>
                        </div>ّ
                        <TextContent />
                        <BoxButton text="ثبت" chooseCancel={chooseCancel} />
                    </div>
            }
        </div>
    )
}
export default EnterContent;